const state = {
  showModal: false,
  modalType: '',
  modalData: {}
}

const getters = {
}

const mutations = {
  UPDATE_SHOW_MODAL: (state, showModal) => {
    state.showModal = showModal
  },
  SET_MODAL_TYPE: (state, modalType) => {
    state.modalType = modalType
  },
  SET_MODAL_DATA: (state, modalData) => {
    state.modalData = modalData
  },
  CLEAR_MODAL: (state) => {
    state.modalData = {}
    state.modalType = ''
  }
}

const actions = {
  closeModal: ({ commit, dispatch }) => {
    commit('UPDATE_SHOW_MODAL', false)

    setTimeout(function () {
      commit('CLEAR_MODAL')
    }, 300)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/modal.js